// extracted by mini-css-extract-plugin
export default {"wrapper":"Continue_wrapper__WhB0j","tableName":"Continue_tableName__H2d6y"};